import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm, Form } from 'redux-form';
import { connect } from 'react-redux';
import { Button, HeadingFive, TinyText, Card } from 'hui/src/styled';
import { PrimaryLink } from '../BaseForm';
import { fillContainer, buttonAlignment, disabledButton } from './shared/SharedStyles';
import { CategoryType } from '../types';
import { EventCategories, EventActions } from '../../../constants/Analytics';
import Field from '../Field';

const EMAIL_REGEX = /.+@.+\..+/;
const PHONE_REFEX = /^\d{8,}$/;
const validateName = value => (value ? undefined : 'Please enter your name');
const validateEmail = value =>
  EMAIL_REGEX.test(value) ? undefined : 'Please enter your email address';
const validatePhone = value =>
  PHONE_REFEX.test(value) ? undefined : 'Please specify the best number to contact you on';

const ContactStep = ({
  handleSubmit,
  user = { name: 'joe', email: 'dada@dad.dsa' },
  invalid,
  initialCategory,
  category
}) => (
  <Form onSubmit={handleSubmit} style={fillContainer}>
    <Card m={0} p={1} center style={fillContainer}>
      <HeadingFive mb={2}>
        How can our {initialCategory.category_person_plural} contact you?
      </HeadingFive>
      <div>
        {user.name ? (
          <div>
            <span style={{ fontWeight: 600 }}>Your Name</span> <p>{user.name}</p>
          </div>
        ) : (
          <Field
            placeholder="Your name"
            name="full_name"
            fieldInfoLabel=" "
            validate={validateName}
          />
        )}
        {user.email ? (
          <div style={{ marginBottom: 25 }}>
            <span style={{ fontWeight: 600 }}>Your Email</span> <p>{user.email}</p>
          </div>
        ) : (
          <Field
            placeholder="Your Email"
            name="email"
            validate={validateEmail}
            fieldInfoLabel="Why do we need your email address?"
            fieldInfoValue="We need your email address so that we can send you the <br />details of businesses who express interest in your job."
          />
        )}
        <Field
          placeholder="Your Phone"
          name="phone"
          validate={validatePhone}
          fieldInfoLabel="Why do we need your phone number?"
          fieldInfoValue="We need your phone number so that businesses who <br />express interest in your job may call you for more details."
        />
      </div>
      <Button
        disabled={!!invalid}
        type={'submit'}
        m={0.5}
        block
        style={!invalid ? buttonAlignment : disabledButton}
        data-ga-interactive={false}
        data-ga-category={EventCategories.POST_JOB_MODAL}
        data-ga-action={EventActions.PRESS_GET_QUOTES_CONTACT_SCREEN}
        data-ga-label={category}
      >
        Get Quotes
      </Button>
      <TinyText style={{ margin: '10px auto' }}>
        By pressing Get Quotes you agree to the{' '}
        <PrimaryLink primary target="_blank" rel="noopener" href="/terms">
          Terms and Conditions
        </PrimaryLink>{' '}
        of hipages.
      </TinyText>
    </Card>
  </Form>
);

ContactStep.propTypes = {
  user: PropTypes.object,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  selectedCategory: CategoryType,
  initialCategory: CategoryType,
  category: PropTypes.string
};

ContactStep.defaultProps = {
  initialCategory: {
    category_person: 'tradie',
    category_person_plural: 'tradies'
  }
};

const ConnectedStep = reduxForm({
  form: 'GQWIZARD',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ContactStep);

export default connect()(ConnectedStep);
